import { createApp } from 'vue'

import App from './App.vue'

import RouterGenerator from './routerGenerator.js'
import Events from '@/events/events.js'
import CustomLocalStorage from '@/shared/utils/customLocalStorage.js'
import OnlineChecker from '@/shared/utils/onlineChecker.js'
import sendBugAlert from '@/shared/errors/sendBugAlert.js'

import AuthService from '@/features/auth/authService'
import setupServices from './setupServices'
import Modal from '@/shared/utils/modal'
import Translator from '@/shared/utils/translator'
import translations from '@/project/translations/all'
import routes from './routes'
import initFloatingVue from './initFloatingVue'
import PermissionsManager from '@/shared/utils/permissionsManager'

import initApp from '@/project/configs/initApp'
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura'

function setup() {
  CustomLocalStorage.init()
  Events.init()
  Translator.init()
  OnlineChecker.init()

  setupServices({ Events, sendBugAlert, modal: Modal, translator: Translator })
  Translator.register(translations)
  PermissionsManager.init()

  const routerGenerator = new RouterGenerator()
  routerGenerator.addRoutes(routes)
  routerGenerator.setAuthChecker(AuthService.isAuthenticated)

  const router = routerGenerator.generate()
  const app = createApp(App)
  app.use(router)
  initFloatingVue(app)
  Translator.install(app)
  PermissionsManager.install(app)
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: false, // <– force le mode clair
      },
    },
  })
  initApp(app)

  return { app, router }
}

export default setup
